import React, { PropTypes } from 'react';
import R from 'ramda';
import { Checkbox, TextField, FontIcon, RadioButtonGroup, RadioButton } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../generic-components/stepper-actions';
import BeddingConfigForm from '../../../profile/edit-modal/bedding-config/bedding-config';

const BedsAndSofasForm = ({ product, updateProduct }) => {
  if (product.checked && !product.bedsAndSofasComplete) {
    return (
      <div style={{ border: '1px solid #e0e0e0', marginBottom: '8px' }}>
        <div style={{ padding: '16px 16px 0' }}>
          <small>Bedding Configuration is important for your partner to load your rates into their booking system.</small><br/>
          <small>
            You only need to enter this information once, and you can always update it later via the <b>Tools</b>.
          </small>
        </div>
        <BeddingConfigForm
          beddingConfig={product.bedsAndSofas}
          sendEditToReducer={({ value }) => {
            const newProduct = { ...product, bedsAndSofas: value };
            updateProduct(newProduct);
          }}
        />
      </div>
    );
  }
  return <div/>;
};

const AddProductsDialog = ({
  onRequestClose,
  contractId,
  locationId,
  data,
  onTextFieldChangeWithKeyPath,
  saveProductsToContract,
  saving,
  openGlobalAlert,
}) => {
  const checkedProducts = data.products.filter(product => product.checked);
  // excluding new product
  const addedOrCheckedProductNames = data.products.filter(p => (p.added || p.checked) && p.productId).map(p => p.productName);
  const notAddedAndExistingProducts = data.products.filter(product => !product.added && product.productId);
  const isCreatingAProduct = data.isFirstProduct || R.isEmpty(notAddedAndExistingProducts);
  const newProductName = (data.products.find(p => !p.productId) || {}).productName;
  const duplicateProductName = Boolean(newProductName && addedOrCheckedProductNames.indexOf(newProductName) > -1);
  const updateProductWithIndex = index => newProd => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index], value: newProd });
  const onClickAdd = () => {
    if (checkedProducts.length + addedOrCheckedProductNames.length > 35) {
      openGlobalAlert({
        text: `We strongly suggest do not add more than 35 room types/products to a rate sheet. Please feel free to contact us through our live chat or email us at support@tourconnect.com, we are happy to help with your rate sheet.
        \n\nAre you sure you still want to add ${
          checkedProducts.length > 1 ? 'these' : 'this'
        } ${checkedProducts.length > 1 ? 'room types/products' : 'room type/product'}?`,
        onOk: () => saveProductsToContract(contractId, locationId, checkedProducts),
      });
    } else {
      saveProductsToContract(contractId, locationId, checkedProducts);
    }
  };
  return (
    <div>
      <div style={{ backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '2%' }} >
        {
          R.call(R.cond([
            [() => data.isFirstProduct, R.always(`Add Your First Room Type/Product`)],
            [() => R.isEmpty(notAddedAndExistingProducts), R.always(`Add Another Room Type/Product`)],
            [R.T, R.always(`Select Room Type(s)/Product(s)`)],
          ]))
        }
      </div>
      <div style={{ padding: '16px', paddingBottom: '8px', overflow: 'auto' }}>
        <div style={{ marginBottom: '12px', marginTop: '12px', fontSize: '16px' }}>
          <b>
            {
              R.call(R.cond([
                [() => isCreatingAProduct, R.always('')],
                [R.T, R.always(`Please select the room types/products you would like to add rates for: `) ],
              ]))
            }
          </b>
        </div>
        {
          data.products.map((product, index) => {
            if (product.added) return undefined;
            if (product.productId) {
              if (addedOrCheckedProductNames.indexOf(product.productName) > -1 && !product.checked) return undefined;
              return (
                <div key={index}>
                  <Checkbox
                    label={<span>{product.productName} <small style={{ color: '#e57373' }}>{product.bedsAndSofasComplete ? `` : 'missing bedding configuration'}</small></span>}
                    checked={Boolean(product.checked)}
                    onCheck={(_, checked) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index, 'checked'], value: checked })}
                  />
                  <BedsAndSofasForm
                    product={product}
                    updateProduct={updateProductWithIndex(index)}
                  />
                </div>
                  );
            }
            if (!data.showCreateProdTF && !isCreatingAProduct) {
              return (
              <div
                key={index}
                className="add-item-card-flex"
                style={{ marginLeft: '2px' }}
                onClick={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'showCreateProdTF'], value: !data.showCreateProdTF })}
              >
                <div style={{ border: `1px dashed #00bcd4`, height: '20px', width: '20px', display: 'inline-block' }} >
                  <FontIcon style={{ verticalAlign: 'middle', color: '#00bcd4', fontSize: '18px', marginTop: '-5px' }} className="tc-icon-add" />
                </div>
                <span style={{ margin: '7px 0px 0px 20px', color: '#00bcd4', display: 'inline-block', verticalAlign: 'middle' }}>
                  {`Create a new product type`}
                </span>
              </div>
              );
            }
            return (
              <div key={index}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {
                    !isCreatingAProduct && <Checkbox
                      checked={product.checked}
                      style={{ width: '44px' }}
                      onCheck={(_, checked) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index, 'checked'], value: checked })}
                    />
                  }
                  <TextField
                    id={`NewProd${index}`}
                    value={product.productName}
                    style={{ width: '280px' }}
                    hintText={`Enter a new name here...`}
                    errorText={duplicateProductName ? `Duplicate with another room type/product` : ''}
                    onChange={(_, value) => {
                      const newProduct = { productName: value, checked: Boolean(value) };
                      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index], value: newProduct });
                    }}
                  />
                </div>
                {
                  product.checked && (
                    <div>
                      <label>What type of product is this?</label> <span style={{ color: 'red' }}>*</span><br/>
                        <RadioButtonGroup
                          name="productType"
                          valueSelected={product.productType}
                          onChange={(e, val) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index], value: {
                            ...product,
                            productType: val,
                            bedsAndSofasComplete: val !== 'Accommodation',
                          } })}
                        >
                          <RadioButton data-cy="nonAccom" label="Non-Accommodation (tours, attractions, etc.)" value="Non-Accommodation" />
                          <RadioButton label="Accommodation (hotels, apartments, B&Bs, etc.)" value="Accommodation" />
                        </RadioButtonGroup>
                    </div>
                  )
                }
                {
                  Boolean(product.checked && product.productType) && (
                    <BedsAndSofasForm
                      product={product}
                      updateProduct={updateProductWithIndex(index)}
                    />
                  )
                }
              </div>
            );
          })
        }
        <StepperActions
          rightButtons={
            <div>
              <FlatButton labelStyle={{ fontWeight: '600' }} label="Cancel" primary onClick={onRequestClose} />
              <FlatButton
                label={`Add Room Type(s)/Product(s)`}
                onClick={onClickAdd}
                disabled={
                  !(
                    checkedProducts.length && checkedProducts.every(prod => {
                      if (!prod.productName) return false;
                      if (!prod.productType) return false;
                      if (prod.productType !== 'Accommodation') return true;
                      const rooms = R.pathOr([], ['bedsAndSofas', 'rooms'], prod);
                      return prod.bedsAndSofasComplete || (rooms && rooms.length && rooms.every(room => room.every(config => config.every(bedding => bedding.count && bedding.bedType))));
                    })
                  ) || duplicateProductName
                }
                secondary
                loader={saving}
                labelStyle={{ fontWeight: '600' }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

AddProductsDialog.propTypes = {
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  data: PropTypes.object,
  productType: PropTypes.string,
};
AddProductsDialog.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default AddProductsDialog;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/add-products.jsx